import React, { FC, MouseEvent } from "react";

import { toast } from "react-toastify";

import { useBoolean } from "~/hooks";

import { Button } from "~/components/atoms";
import { LabelWithTextArea, TogglablePostHeader } from "~/components/molecules";

import { AiCompanyContextType } from "~/domains";

type PropsType = {
  aiCompanyContext: AiCompanyContextType;
  className?: string;
  refetch: () => void;
};

export const AiCompanyContextDetail: FC<PropsType> = ({
  aiCompanyContext,
  className = "",
  refetch,
}: PropsType) => {
  const { isChecked, toggle } = useBoolean(false);

  const handleToggle = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    toggle();
  };

  const handleDelete = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (confirm("本当に削除しますか？")) {
      // TODO: Implement delete API when available
      toast.success("削除しました");
      refetch();
    }
  };

  return (
    <div className={`${className}`}>
      <div className="space-y-6">
        <TogglablePostHeader
          avatarUrl={aiCompanyContext.createdByEmployee.avatarUrl}
          employeeName={aiCompanyContext.createdByEmployee.name}
          createdAt={aiCompanyContext.updatedAt}
          handleToggle={handleToggle}
          isOpen={isChecked}
        />
        {isChecked && (
          <>
            <LabelWithTextArea
              labelText="AIカスタマイズ"
              name="context"
              placeholder="AIカスタマイズ"
              rows={6}
              value={aiCompanyContext.context}
              disabled
            />
            <div className="flex justify-end">
              <Button
                onClick={handleDelete}
                size="sm"
                color="red"
                text="削除する"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
